<template>
  <div class="fff">
    <div class="b_title">
      <img v-if="system == 'iOS'" src="@/assets/img/i.png" alt="" />
      <img v-else src="@/assets/img/a.png" alt="" />
      <div class="b_t_title Noto SansBold">
        {{ system == "iOS" ? $t("billing.iPhone") : $t("billing.android") }}
      </div>
      <div class="b_t_day">
        {{ $t("billing.expires") }}
        {{
          parseInt(
            (new Date(systems.vip_endtime).getTime() - new Date().getTime()) /
              1000 /
              60 /
              60 /
              24
          )
        }}
        days
      </div>
    </div>
    <div class="page_bo_li biling_li">
      <div class="fl">
        <span>{{ $t("billing.accountType") }}</span
        >{{ systems.name }}
      </div>
      <div class="fl">
        <span>{{ $t("billing.auto") }}</span>
        <div :class="isoks == 1 ? 'ok' : ''" @click="getisok()">
          <a></a>
        </div>
      </div>
      <div class="fl">
        <span>{{ $t("billing.expiry") }}</span
        >{{ systems.vip_endtime }}
      </div>
    </div>
    <div class="page_bo_li biling_li">
      <div class="bi_title Noto SansBold">{{ $t("billing.renew") }}</div>
      <div class="bli">
        <div class="bli_l">
          <div v-for="(item, index) in taocan" :key="index">
            <img v-if="Renew == item.id" src="@/assets/img/qdui.png" alt="" />
            <img
              v-else
              @click="Renew = item.id"
              src="@/assets/img/qnodui.png"
              alt=""
            />
            {{ item.length }}-{{ $t("billing.month")
            }}<b class="Noto SansBold">{{ $t('$') }}{{ item.price }}</b>
            <s>{{ $t('$') }}{{ item.del_price }} </s>
          </div>
        </div>
        <div class="bli_r">
          <div @click="goorder" class="loginButton bilingButton">
            {{ $t("billing.pay") }}
          </div>
          <div @click="goorder" class="bilingButton2">
            {{ $t("billing.additional") }}
          </div>
        </div>
      </div>
    </div>
    <!-- v-show="systems.name == 'Basic' || systems.name == 'Basic'" -->
    <div class="page_bo_li biling_li">
      <div class="bi_title b_table_tit">{{ $t("billing.feature") }}</div>
      <!-- <div
        @click="$router.push({ path: '/ChoosCopy' })"
        class="loginButton b_tableButton"
      >
        Upgrade to Premium
      </div> -->
      <table cellspacing="0" rules="all" class="b_table">
        <tr>
          <th>{{ $t("billing.features") }}</th>
          <!-- v-show="litem.name != 'Basic' && litem.name != 'Basic'" -->
          <th v-for="(litem, index1) in list" :key="index1">
            {{ litem.name }}
          </th>
        </tr>
        <tr v-for="(item, index) in list[0].ability_list" :key="index">
          <td>{{ item.name }}</td>
          <!-- v-show="itemqwe.name != 'Basic' && itemqwe.name != 'Basic'" -->
          <td v-for="(itemqwe, index1) in list" :key="index1">
            <img
              v-show="list[index1].ability_list[index].checked"
              src="@/assets/img/dui.png"
              alt=""
            />
            {{ list[index1].ability_list[index].checked ? "" : "--" }}
          </td>
        </tr>
      </table>
    </div>
    <div class="Popup syy" v-if="isok > 0 && isok < 7">
      <!-- @click="isok = 0" -->
      <div class="Popups_w"></div>
      <div :class="'Popups Popups' + isok">
        <img src="@/assets/img/x.png" @click="isok = 0" class="close" />
        <div v-if="isok == 1">
          <div class="Popups_title">{{ $t("billing.cancel") }}</div>
          <div class="Popups_con">
            {{ $t("billing.popups_con1") }}
          </div>
          <div @click="isok = 2" class="loginButton PopupsButton">
            {{ $t("billing.leave") }}
          </div>
          <div @click="isok = 0" class="Popups_Button">
            {{ $t("billing.stay") }}
          </div>
        </div>
        <!---->
        <div v-if="isok == 2">
          <div class="Popups_title">{{ $t("billing.why") }}</div>
          <div class="Popups_con" style="margin-bottom: 10px">
            {{ $t("billing.your") }}
          </div>
          <div class="reason" @click="editYY(1)">
            <!---->
            <img v-if="yy == 1" src="@/assets/img/qdui.png" alt="" />
            <img v-if="yy != 1" src="@/assets/img/qnodui.png" alt="" />
            {{ $t("billing.problems") }}
          </div>
          <div class="reason" @click="editYY(2)">
            <!---->
            <img v-if="yy == 2" src="@/assets/img/qdui.png" alt="" />
            <img v-if="yy != 2" src="@/assets/img/qnodui.png" alt="" />
            {{ $t("billing.i") }}
          </div>
          <div class="reason" @click="editYY(3)">
            <!---->
            <img v-if="yy == 3" src="@/assets/img/qdui.png" alt="" />
            <img v-if="yy != 3" src="@/assets/img/qnodui.png" alt="" />
            {{ $t("billing.noRenewal3") }}
          </div>
          <div class="reason" @click="editYY(4)">
            <!---->
            <img v-if="yy == 4" src="@/assets/img/qdui.png" alt="" />
            <img v-if="yy != 4" src="@/assets/img/qnodui.png" alt="" />
            {{ $t("billing.too") }}
          </div>
          <div class="reason" @click="editYY(5)">
            <!---->
            <img v-if="yy == 5" src="@/assets/img/qdui.png" alt="" />
            <img v-if="yy != 5" src="@/assets/img/qnodui.png" alt="" />
            {{ $t("billing.found") }}
          </div>
          <div class="reason" @click="editYY(6)">
            <!---->
            <img v-if="yy == 6" src="@/assets/img/qdui.png" alt="" />
            <img v-if="yy != 6" src="@/assets/img/qnodui.png" alt="" />
            {{ $t("billing.other") }}
          </div>
          <input
            v-if="yy != 6"
            disabled="disabled"
            type="text"
            :placeholder="$t('Comments')"
            class="other"
          />
          <input
            v-if="yy == 6"
            v-model="inputs"
            type="text"
            :placeholder="$t('Comments')"
            class="other"
          />
          <!---->
          <div
            :class="
              yy > 0
                ? 'loginButton PopupsButton'
                : 'loginButton PopupsButton ssr'
            "
            @click="yy > 0 ? (isok = 3) : ''"
          >
            {{ $t("billing.continue") }}
          </div>
          <!---->
          <div class="Popups_Button" @click="isok = 1">
            {{ $t("billing.back") }}
          </div>
        </div>
        <!---->
        <div v-if="isok == 3">
          <div class="Popups_title">
            {{ $t("billing.our") }}
          </div>
          <div class="Popups_con">
            {{ $t("billing.we") }}
            <!-- ( -->
            <a href="mailto:support@spylix.com">support@spylix.com</a>.
            <!-- ),<a>+1(855)896-0187</a> , or in a live chat -->
            <!-- on <a>spylix</a>website -->
          </div>
          <div @click="isok = 4" class="loginButton PopupsButton">
            {{ $t("billing.continue") }}
          </div>
          <div @click="isok = 2" class="Popups_Button">
            {{ $t("billing.back") }}
          </div>
        </div>
        <!---->
        <div v-if="isok == 4">
          <div class="Popups_title">
            {{ $t("billing.enter") }}
          </div>
          <input
            v-model="Email"
            type="text"
            :placeholder="$t('Email*')"
            class="other"
            style="margin-bottom: 10px"
          />
          <div class="Popups_con">
            {{ $t("billing.tips") }}
          </div>
          <div
            @click="Email != '' ? getsend() : ''"
            :class="
              Email != ''
                ? 'loginButton PopupsButton'
                : 'loginButton PopupsButton ssr'
            "
          >
            {{ $t("billing.continue") }}
          </div>
          <!---->
          <div @click="isok = 3" class="Popups_Button">
            {{ $t("billing.back") }}
          </div>
        </div>
        <!---->
        <div v-if="isok == 5">
          <div class="Popups_title">
            {{ $t("billing.received") }}
          </div>
          <input
            v-model="Comments"
            type="text"
            :placeholder="$t('Code*')"
            class="other"
            style=""
          />
          <div
            @click="noRenewal"
            :class="
              Comments != ''
                ? 'loginButton PopupsButton'
                : 'loginButton PopupsButton ssr'
            "
          >
            {{ $t("billing.submit") }}
          </div>
          <!---->
          <div @click="isok = 4" class="Popups_Button">
            {{ $t("billing.never") }}
          </div>
        </div>
        <!---->
        <div v-if="isok == 6">
          <div class="Popups_title">{{ $t("billing.subscription") }}</div>
          <div class="Popups_con">
            {{ $t("billing.has") }}
          </div>
          <div @click="cancel" class="loginButton okButton">
            {{ $t("billing.ok") }}
          </div>
        </div>
      </div>
    </div>
    <paddler ref="paddler" @paySuccess="paySuccess" />
  </div>
</template>

<script>
import {
  indexAccountInfo,
  vipChangeAuto,
  apiEmssend,
  RenewalAdd,
  getPackage,
  createVipOrder,
  Ability,
} from "@/api/user";
import paddler from "./paddler/paddler";

export default {
  name: "HelloWorld",
  components: {
    paddler,
  },
  data() {
    return {
      systems: {
        vip_endtime: "",
        name: "",
        is_auto_renewal: 0,
      },
      taocan: [],
      system: localStorage.getItem("system"),
      isok: 0,
      isoks: 0,
      Email: "",
      Comments: "",
      inputs: "",
      yy: 0,
      Renew: 0,
      list: [],
      msg: "",
    };
  },
  mounted() {
    this.getindex();
    Ability({ type: this.system === "iOS" ? 2 : 1 }).then((adj) => {
      this.list = adj.data;
    });
  },
  methods: {
    editYY(yy) {
      console.log(yy);
      this.yy = this.yy === yy ? 0 : yy;
    },
    getindex() {
      indexAccountInfo({ equipment_id: localStorage.getItem("systemId") }).then(
        (adj) => {
          console.log(adj);
          this.systems = adj.data.vipinfo;
          this.isoks = adj.data.vipinfo.is_auto_renewal;
          this.Renew = adj.data.vipinfo.pkg_id;
          getPackage({ pkg_id: adj.data.vipinfo.pkg_id }).then((qaz) => {
            this.taocan = qaz.data.taocan;
            console.log(qaz);
          });
        }
      );
    },
    getisok() {
      if (parseInt(this.isoks) !== 1) {
        this.isoks = 2;
        this.isok = 0;
        vipChangeAuto({
          equipment_id: localStorage.getItem("systemId"),
          state: 1,
        }).then((adj) => {
          console.log(adj);
          if (adj.code === 1) {
            this.isoks = 1;
          }
        });
      } else {
        this.isok = 1;
      }
    },
    getsend() {
      let logins = {
        email: this.Email,
        event: "cancel_auto",
      };
      apiEmssend(logins).then((adj) => {
        console.log(adj);
        if (parseInt(adj.code) === 1) {
          this.isok = 5;
        } else {
          this.$message.error(adj.msg);
        }
      });
    },
    cancel() {
      this.isok = 0;
      // this.isoks = 1
    },
    noRenewal() {
      let reasons = [
        "",
        this.$t("billing.problems"),
        this.$t("billing.i"),
        this.$t("billing.noRenewal3"),
        this.$t("billing.too"),
        this.$t("billing.found"),
        this.inputs,
      ];
      let reason = reasons[this.yy];
      let key = {
        equipment_id: localStorage.getItem("systemId"),
        reason: reason,
        email: this.Email,
        code: this.Comments,
      };
      RenewalAdd(key).then((adj) => {
        if (parseInt(adj.code) === 1) {
          this.isok = 6;
          this.isoks = 0;
        } else {
          this.Comments = null;
          this.$message.error(adj.msg);
        }
      });
    },
    goorder() {
      let key = {};
      let temp = null;
      for (var asd = 0; asd < this.taocan.length; asd++) {
        if (this.Renew === this.taocan[asd].id) {
          console.log(this.taocan[asd]);
          console.log(this.taocan[asd]);
          temp = this.taocan[asd];
          key = {
            name: this.systems.name,
            order_price: this.taocan[asd].del_price,
            pay_price: this.taocan[asd].price,
            package_price_id: this.taocan[asd].id,
            type: this.system === 1 ? 1 : 2,
          };
        }
      }
      this.$nextTick(() => {
        createVipOrder(key).then(({ code, data, msg }) => {
          if (code !== 1) {
            this.$message(msg);
            return false;
          }
          this.$refs.paddler.showEdit(data.id, temp.paddle_product_id);
        });
      });
    },
    paySuccess() {
      // this.$notify({
      //   title: '支付成功',
      //   message: '你已成功支付,即将跳转到绑定设备页面,走绑定流程',
      //   type: 'success'
      // })
      console.log("支付成功");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fff {
  width: 100%;
  background: #fff;
  min-height: 100%;
  overflow: hidden;
}
.b_title {
  height: 40px;
  margin: 45px 0 35px 5%;
  overflow: hidden;
}
.b_title img {
  float: left;
  height: 40px;
  display: block;
  width: 40px;
  margin-right: 20px;
}
.b_t_title {
  font-size: 20px;
  color: #000927;
  font-weight: 700;
  line-height: 20px;
}
.b_t_day {
  font-size: 13px;
  color: #01dbb3;
  font-weight: 400;
  line-height: 14px;
  margin-top: 6px;
  height: 14px;
}
.biling_li {
  padding: 20px 0;
}
.biling_li .fl {
  float: left;
  width: 35%;
  line-height: 22px;
  height: 22px;
  margin: 9px 9px 9px 30px;
  color: #999;
  font-size: 14px;
  overflow: hidden;
}
.biling_li .fl span {
  display: block;
  width: 110px;
  font-size: 14px;
  color: #3f3f3f;
  float: left;
}
.biling_li .fl div {
  width: 44px;
  float: left;
  height: 22px;
  border-radius: 22px;
  background: #999;
  cursor: pointer;
  -webkit-transition: all 0.4s;
  transition: all 0.4s;
}
.biling_li .fl div a {
  display: block;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #fff;
  margin: 2px;
  -webkit-transition: all 0.4s;
  transition: all 0.4s;
}
.biling_li .fl div.ok {
  background: #00eec3;
}
.biling_li .fl div.ok a {
  margin-left: 24px;
}
.bi_title {
  line-height: 55px;
  font-size: 16px;
  color: #000927;
  font-weight: 700;
  text-indent: 30px;
}
.bli {
  overflow: hidden;
  padding-bottom: 20px;
}
.bli_l {
  float: left;
  width: 50%;
  font-size: 14px;
  color: #45484d;
}
.bli_l div {
  overflow: hidden;
  height: 40px;
  line-height: 40px;
}
.bli_l div img {
  float: left;
  width: 20px;
  height: 20px;
  display: block;
  margin: 10px 10px 0 30px;
  cursor: pointer;
}
.bli_l div b {
  margin: 0 5px 0 10px;
}
.bli_l div s {
  color: #9f9f9f;
}
.bli_r {
  float: left;
  width: 50%;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAIAAACQd1PeAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQ1IDc5LjE2MzQ5OSwgMjAxOC8wOC8xMy0xNjo0MDoyMiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTkgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOkI4MjY3MTY2RUM0QjExRUJCMURBRjY2RUE2NDY1NzU4IiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOkI4MjY3MTY3RUM0QjExRUJCMURBRjY2RUE2NDY1NzU4Ij4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6QjgyNjcxNjRFQzRCMTFFQkIxREFGNjZFQTY0NjU3NTgiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6QjgyNjcxNjVFQzRCMTFFQkIxREFGNjZFQTY0NjU3NTgiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz5HVGmWAAAAD0lEQVR42mJ4+PgZQIABAAVTAqu9pHiVAAAAAElFTkSuQmCC)
    0 repeat-y;
  height: 120px;
}
.bilingButton {
  width: 320px;
  height: 44px;
  line-height: 44px;
  font-size: 15px;
  margin-bottom: 20px;
}
.bilingButton2 {
  width: 320px;
  height: 40px;
  line-height: 40px;
  font-size: 15px;
  border: 2px solid #00eec3;
  border-radius: 22px;
  text-align: center;
  margin: 0 auto;
  cursor: pointer;
}
.b_table_tit {
  float: left;
}
.b_tableButton {
  float: right;
  width: 270px;
  height: 44px;
  line-height: 44px;
  font-size: 15px;
  margin-top: 22px;
  margin-right: 66px;
  margin-bottom: 30px;
}
.b_table {
  width: 100%;
  font-size: 14px;
  color: #45484d;
  border-bottom: 1px solid #e1e3e6;
  border-top: 2px solid;
  border-color: #e1e3e6;
}
.b_table th {
  background: #f6f8fa;
  font-size: 13px;
  color: #45484d;
  width: auto;
  padding: 0;
  margin: 0;
  height: 60px;
  border: 1px solid #e1e3e6;
  text-align: center;
}
.b_table tr td:first-child,
.b_table tr th:first-child {
  text-align: left;
  text-indent: 30px;
}
.b_table td {
  text-align: center;
  height: 50px;
  line-height: 50px;
}
.b_table td img {
  width: 16px;
  display: block;
  margin: 0 auto;
}
.Popups_title {
  margin-top: 20px;
}
.Popups {
  padding: 0 50px;
}
.Popups1 {
  width: 400px;
  height: 260px;
  margin: -130px -250px;
}
.Popups2 {
  width: 400px;
  height: 480px;
  margin: -240px -250px;
}
.Popups3 {
  width: 400px;
  height: 270px;
  margin: -135px -250px;
}
.Popups4 {
  width: 400px;
  height: 330px;
  margin: -165px -250px;
}
.Popups5,
.Popups6 {
  width: 400px;
  height: 260px;
  margin: -130px -250px;
}
.Popups_title {
  font-size: 16px;
  color: #000927;
  font-weight: 400;
}
.Popups_con {
  font-size: 14px;
  color: grey;
  margin-bottom: 40px;
}
.Popups_con a {
  color: #0080ff;
}
.PopupsButton {
  width: 180px;
  height: 40px;
  float: left;
  line-height: 40px;
  font-size: 15px;
}
.Popups_Button {
  cursor: pointer;
  width: 176px;
  height: 36px;
  line-height: 36px;
  text-align: center;
  font-size: 15px;
  color: #000927;
  float: left;
  border: 2px solid #00eec3;
  border-radius: 22px;
  margin-left: 40px;
}
.reason {
  overflow: hidden;
  line-height: 34px;
  height: 34px;
  font-size: 13px;
  color: #45484d;
  cursor: pointer;
}
.reason img {
  float: left;
  margin: 7px 10px 0 0;
  width: 20px;
  height: 20px;
}
input.other {
  width: 398px;
  height: 38px;
  line-height: 38px;
  border: 1px solid #d5d7db;
  border-radius: 8px;
  background: #f6f8fa;
  font-size: 13px;
  text-indent: 10px;
  margin-bottom: 40px;
}
.ssr {
  color: rgba(0, 9, 39, 0.4);
  background: rgba(0, 238, 195, 0.4);
}
.okButton {
  width: 270px;
  height: 40px;
  line-height: 40px;
  font-size: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/Billing.vue